import { Component, OnInit } from "@angular/core";
import * as PIXI from "pixi.js";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  async ngOnInit() {
    PIXI.Assets.addBundle("fonts", [
      { alias: "ChosunGs", src: "/assets/fonts/ChosunGs.ttf" },
      { alias: "NanumPen", src: "/assets/fonts/NanumPen.ttf" },
      { alias: "NotoSansKR-Bold", src: "/assets/fonts/NotoSansKR-Bold.ttf" },
      {
        alias: "NotoSansKR-Regular",
        src: "/assets/fonts/NotoSansKR-Regular.ttf",
      },
      { alias: "NotoSansKR-Thin", src: "/assets/fonts/NotoSansKR-Thin.ttf" },
    ]);

    // Load the font bundle
    await PIXI.Assets.loadBundle("fonts");
    // .then((data) => {
    // console.log("data", data);
    // });
  }
}
